import React, { useState, useEffect, useRef, useContext } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './TextModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { constructUrl } from '../../../../utils/UrlConstructor';
import { AppContext } from "../../../../AppContext.jsx";
import { TextPopUpButtonClicked, TextPopUpHotSpotClicked } from "../../../../utils/Analytics";
import ModalOverlay from '../ModalOverlay';
import ReactHtmlParser from "react-html-parser";
import { getTrackingParameter } from '../../../../utils/StoreConfigManager';

const isMobile = isMobileDevice();

const TextModal = ({ modalContent, onModalHidden, onClose, primaryColor, secondaryColor }) => {
    const { title, subtitle, body, button_copy, button_url, url } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const [modalActive, setModalActive] = useState();

    const modalRef = useRef();

    const { currentSceneName } = useContext(AppContext);

    useEffect(() => {
        fetchFontStyles();
        addListeners();
        TextPopUpHotSpotClicked(currentSceneName, body);

        return (() => {
            removeListeners();
        });

    }, []);

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
        closeModal();
    }

    const closeModal = () => {
        if (onClose) {
            setModalActive(false);
            onClose();
        }
    }

    const handleClick = () => {
        TextPopUpButtonClicked(currentSceneName);
        const attRedirectPath = constructUrl(button_url);
        const trackingParam = getTrackingParameter();
        const trackingParamUrl = `${attRedirectPath}?${trackingParam}`

        window.open(trackingParamUrl, '_blank');
    }

    const productButton = () => {
        return (
            <div className="text-button-container" style={{ margin: url ? '20px auto 0' : '0 auto' }}>
                <Button
                    hoverStyleChange={true}
                    onClick={handleClick}
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    className="text-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                    style={{ padding: '0', margin: '0 1%', borderRadius: '4px', width: '65%', height: '3em' }}
                    primaryBorderColor='white'
                    secondaryBorderColor='white'
                    primaryBorderWidth='0px'
                    secondaryBorderWidth='0px'
                    insetBorder={true}
                    padded={false}
                >
                <p className='obsessvr-regularFont'>
                    {button_copy}
                </p>
            </Button></div>
        )
    }

    const textContainer = () => {
        return (
            <div className='text-modal-text-container'>
                <pre
                    style={{
                        fontSize: isMobile ? '12px' : '14px',
                        fontFamily: fontStyles.popUpText.name,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {ReactHtmlParser(body)}
                </pre>
            </div>
        )
    }

    const titleRender = () => {
        return (
            <div className='text-modal-title-container'>
                <span
                    style={{
                        fontSize: fontStyles.popUpTitle.size,
                        fontFamily: fontStyles.popUpTitle.name
                    }}>
                    {title}
                </span>
            </div>
        );
    }

    const subtitleRender = () => {
        return (
            <div className='text-modal-subtitle-container'>
                <span
                    style={{
                        fontSize: fontStyles.popUpSubtitle.size,
                        fontFamily: fontStyles.popUpSubtitle.name
                    }}>
                    {subtitle}
                </span>
            </div>
        );
    }

    const imageRender = () => {
        const imageUrl = constructUrl(url);
        return (
            <div className="text-modal-img-container">
                <img 
                    style={
                        {
                            maxWidth: '100%'
                        }
                    }
                    src={imageUrl} />
            </div>
        )
    }

    const renderModalContent = () => {
        return (
            <div className='text-modal-content' style={{ textAlign: 'center', margin: '20px 0px' }} ref={modalRef}>
                {subtitle && subtitleRender()}
                {title && titleRender()}
                {url && imageRender()}
                {body && textContainer()}
                {button_copy && productButton()}
            </div>
        )
    }
    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName={url ? "text-modal-image-container" : "text-modal-container"} onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default TextModal;


